import { AxiosError } from 'axios';
import { POST_TUTORIALS_ATTACHED_FILE } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { PresignedUrlResponse } from '../../models/PresignedUrl';

// =============================================================================
// Request & Response Model
// =============================================================================

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PresignedUrlResponse) => void;
  onError?: (err: AxiosError) => void;
}

export const usePostUploadTutorialsDocument = ({ onSuccess, onError }: Input) => {
  const postUploadTutorialsDocument = async (payload: string) => {
    const res = await axiosClient.post<PresignedUrlResponse>(POST_TUTORIALS_ATTACHED_FILE, {
      fileName: payload,
    });
    return res.data;
  };

  return useCustomMutation(postUploadTutorialsDocument, {
    onSuccess,
    onError,
  });
};
